export enum LocalStoreEnums {
  INVOICE = '_revd_invoice',
  ORG = '_revd_org',
  TOKEN = '_revd_tkn',
  USER = '_revd_user',
  CUSTOMER_USER = '_revd_customer',
  THEME = '_theme',
}
